export default function ResultsSummary({ insights }) {
  if (!insights?.length) return null;

  const highlights = insights.slice(0, 3);

  return (
    <div className="results-summary">
      <h2>At a Glance</h2>
      <ul className="results-summary__list">
        {highlights.map((item) => (
          <li key={item.id} className="results-summary__item">
            <span className={`results-summary__dot ${item.levelClass}`} />
            <span className="results-summary__label">{item.title}</span>
            <span className={`results-summary__level ${item.levelClass}`}>{item.level}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
